import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('SearchResults')
export class SearchResults {
    @JsonProperty('count', Number, true)
    count = 0;

    @JsonProperty('next', String, true)
    next: string = null;

    @JsonProperty('previous', String, true)
    previous: string = null;
}
